import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface SheetProps {
  $tone?: 'primary' | 'secondary' | 'accent';
  $gutter?: 'tiny' | 'small';
  $borderRadius?: 'large';
}

export const Sheet = styled.div.withConfig({ componentId: 'sc-4vi3va-0' })<SheetProps>`
    --sheet-bg: var(--c-bg-alt);

    padding: ${size(4)} ${size(2)};
    background-color: var(--sheet-bg);
    border-radius: ${size(2)};

    ${(props) => props.theme.breakpoint.Md} {
        padding: ${size(5)} ${size(7)};
    }

    ${({ $tone }) =>
      $tone === 'primary'
        ? css`
                  --sheet-bg: var(--c-sheet-primary);
              `
        : $tone === 'secondary'
          ? css`
                  --sheet-bg: var(--c-sheet-secondary);
              `
          : $tone === 'accent'
            ? css`
                  --sheet-bg: var(--c-sheet-accent);
              `
            : undefined}

    ${({ $gutter }) =>
      $gutter === 'tiny'
        ? css`
                  padding: ${size(2)};
                  border-radius: ${size(1.5)};

                  ${(props) => props.theme.breakpoint.Md} {
                      padding: ${size(2)};
                  }
              `
        : $gutter === 'small'
          ? css`
                  padding: ${size(2)};
                  border-radius: ${size(1.5)};

                  ${(props) => props.theme.breakpoint.Md} {
                      padding: ${size(3)};
                  }
              `
          : undefined}

${({ $borderRadius }) =>
  $borderRadius === 'large'
    ? css`
                  border-radius: ${size(2)};
              `
    : undefined}
`;
